<template>
    <ActionDialog
        v-model="internal_value"
        :header_divider="false"
        :title="title"
        bold_title
    >
        <template #content>
            <v-window
                v-model="window"
                :disabled="true"
            >
                <v-window-item value="ocr">
                    <PaymentOcr @ocr="handle_public_ocr" />
                </v-window-item>
                <v-window-item value="provider">
                    <PaymentProvider
                        :payment_amount_and_currency="payment_amount_and_currency"
                        @demo="handle_demo_payment"
                        @mobile_number="mobile_number = $event"
                        @provider="selected_provider = $event"
                    />
                </v-window-item>
                <v-window-item value="request">
                    <PaymentRequest
                        :mobile_number="mobile_number"
                        :payment_amount_and_currency="payment_amount_and_currency"
                        :public_url="public_url"
                        :selected_ocr="selected_ocr"
                        :selected_provider="selected_provider"
                        @feedback="feedback = $event"
                    />
                </v-window-item>
                <v-window-item value="feedback">
                    <PaymentFeedback
                        :feedback="feedback"
                        :public_url="public_url"
                        @close="internal_value = false"
                    />
                </v-window-item>
            </v-window>
        </template>
    </ActionDialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { locales_mixin } from '@old/mixins/locales_mixin'
import PaymentProvider from '@old/components/payments/PaymentProvider.vue'
import PaymentRequest from '@old/components/payments/PaymentRequest.vue'
import PaymentOcr from '@old/components/payments/PaymentOCR.vue'
import PaymentFeedback from '@old/components/payments/PaymentFeedback.vue'
import { actions_mixin } from '@old/mixins/actions_mixin'
import ActionDialog from '@old/components/action_dialog'

export default {
    name: 'Payments',
    props: {
        modelValue: {
            type: Boolean,
        },
    },
    mixins: [actions_mixin, locales_mixin],
    components: {
        ActionDialog,
        PaymentFeedback,
        PaymentOcr,
        PaymentRequest,
        PaymentProvider,
    },
    data() {
        return {
            internal_value: false,
            selected_ocr: null,
            selected_provider: null,
            feedback: null,
            window: 'ocr',
            mobile_number: '',
            public_url: false,
        }
    },
    computed: {
        payment_amount_and_currency() {
            const { total_remaining_transaction_amount, currency } = this.payment

            if (this.payment.reference === 'amortization') {
                const print_amount = this.deep_get(this.payment, 'print.amount', 0)
                const print_currency = this.deep_get(this.payment, 'print.currency')

                if (print_amount < total_remaining_transaction_amount) {
                    return {
                        amount: print_amount,
                        currency: print_currency,
                    }
                }
                return {
                    amount: total_remaining_transaction_amount,
                    currency: currency,
                }
            }

            if (total_remaining_transaction_amount) {
                return {
                    amount: total_remaining_transaction_amount,
                    currency: currency,
                }
            }
            return {
                amount: this.deep_get(this.payment, 'ocr.amount', 0),
                currency: this.deep_get(this.payment, 'ocr.currency'),
            }
        },
        title() {
            if (this.window !== 'feedback') return this.translate('common.see_status_or_pay_directly')
            return ''
        },
        ...mapGetters(['token']),
        ...mapState(['actions_render_key', 'payment', 'public_token']),
    },
    watch: {
        payment: {
            handler(payment) {
                if (Object.keys(payment).length) {
                    this.internal_value = true
                    if (payment.ocr.status === 'pending_payment') {
                        this.feedback = 'pending'
                    } else {
                        this.feedback = null
                    }
                    this.selected_provider = null
                    const { ocr } = payment.ocr
                    if (ocr) {
                        this.selected_ocr = ocr
                    }
                }
            },
            immediate: true,
        },
        async internal_value(value) {
            if (!value) {
                await this.set_state_property({
                    property: 'payment',
                    data: {},
                })
                if (this.window === 'feedback') {
                    await this.update_actions_render_key()
                }
                this.selected_ocr = null
                this.selected_provider = null
                this.feedback = null
                this.window = 'ocr'
                this.mobile_number = ''
            }
        },
        selected_ocr(value) {
            if (value) this.window = 'provider'
        },
        selected_provider(value) {
            if (value) this.window = 'request'
        },
        feedback(value) {
            if (value) this.window = 'feedback'
        },
    },
    methods: {
        handle_public_ocr(ocr) {
            // Advance to step 2 (provider), where the status banner derived from
            // payment_status is shown (ADA-4286 B2). The old already_paid / pending
            // feedback hops are replaced by that banner.
            this.selected_ocr = ocr
            this.public_url = true
        },
        async handle_demo_payment(amount) {
            const ocr_number_id = this.payment.ocr._id
            const payload = {
                url: '/demo--payments',
                data: {
                    amount: Number(amount),
                    ocr_number_id: ocr_number_id,
                },
            }
            if (!this.token) {
                await this.get_public_token()
                payload.token = this.public_token
            }
            const response = await this.api_post(payload)
            if (response.status === 200) {
                this.feedback = 'paid'
            }
        },
        ...mapActions(['set_state_property']),
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeUnmount() {},
    unmounted() {},
}
</script>

<style scoped lang="sass"></style>
